import { InventoryProjectionStatus } from "@redotech/crdb-enums/inventory/inventory-projection-status";

export const inventoryProjectionStatusLabels: Record<
  InventoryProjectionStatus,
  string
> = {
  [InventoryProjectionStatus.Covered]: "Covered",
  [InventoryProjectionStatus.CoveredByInbound]: "Covered by inbound",
  [InventoryProjectionStatus.Short]: "Short",
};

export const inventoryProjectionLoadingLabel = "Still loading";

export const inventoryProjectionPendingLabel = "Pending";
